import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
export function StickyOrderButton() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Mostrar el botón cuando el usuario haya scrolleado más de 400px
      if (window.scrollY > 400) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className={`fixed bottom-0 left-0 right-0 z-50 transition-transform duration-300 ${isVisible ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-264">
      <div className="bg-gradient-to-t from-white via-white to-white/80 backdrop-blur-sm border-t border-gray-200 shadow-[0_-4px_20px_rgba(0,0,0,0.1)] py-3 px-4" data-id="element-265">
        <div className="container mx-auto flex justify-center" data-id="element-266">
          <a href="https://go.trkrgodom.com/click" className="w-full max-w-md" data-id="element-267">
            <Button size="xl" className="shadow-[0_0_30px_rgba(40,167,69,0.6)] w-full" data-id="element-268">
              Order Now & Save 50%
            </Button>
          </a>
        </div>
      </div>
    </div>;
}